import {ROOT_FLOTTA_POOL} from '../app-routing-roots';

export enum FlottaPoolRoutingRoots {
	DASHBOARD = 'dashboard',
	INSERT = 'insert',
	TRANSFER = 'transfer',
	VEHICLES = 'vehicles-list',
	CLUSTER = 'cluster',
	HELP_CENTER = 'help-center',
	HISTORY = 'history',
	SETTINGS = 'settings',
	DETAILS = 'details',
	INVENTORY = 'inventory',
	VEHICLE = 'vehicle',
	PERFORMANCE = 'performance',
	INVENTORY_LIST_HELP_CENTER = 'inventory-list-help-center',
}
